import React from 'react';
import _ from 'lodash';


import component, {classnames} from './component';
import Link from './Link';
import {ArrowRight} from './icons';


export default component('DataEditButton', function({data, text, className, onClick, backgroundType = 'dark'}) {

  const cls = classnames('DataEditButton', className, {
    [`DataEditButton--${_.capitalize(backgroundType)}`]: true,
    'DataEditButton--NoClick': !onClick
  });

  return (
    <div className={cls} onClick={onClick}>
      <div className='DataEditButton-Text'>{text}</div>
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/DataEditButton.js